module.exports = __webpack_public_path__ + "static/img/banner.8ddf697.png";


//////////////////
// WEBPACK FOOTER
// ./static/poup/banner.png
// module id = eFnY
// module chunks = 1